import React from "react";
import Footer from "../components/Footer"; // Pie de página
import NavigationBar from "../components/NavigationBar"; // Menú hamburguesa en móviles
import fondoImagen from "../assets/images/jetblack-bg.png"; // Imagen de fondo
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";

const ContactPage = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Thank you! Your message has been sent to the company.");
  };

  return (
    <div className="page-container">
      {/* Menú hamburguesa en móviles */}
      <NavigationBar />

      {/* Sección 1: Imagen de fondo */}
      <div className="hero-section">
        <img src={fondoImagen} alt="Background" className="background-image" />
        <div className="hero-overlay">
          <h1 className="hero-text">Welcome to Jet Black Limo Service</h1>
        </div>
      </div>

      {/* Sección 2: Tarjetas de contacto */}
      <div className="contact-section">
        <div className="cards-row">
          <div className="card">
            <FaMapMarkerAlt className="icon" />
            <h3 className="card-title">Yorktown Heights, NY</h3>
          </div>
          <div className="card">
            <FaPhoneAlt className="icon" />
            <h3 className="card-title">+1 (914) 962-8444</h3>
          </div>
          <div className="card">
            <FaEnvelope className="icon" />
            <h3 className="card-title">jetblacklimo@aol.com</h3>
          </div>
        </div>
      </div>

      {/* Sección 3: Mapa y formulario */}
      <div className="map-and-form-container">
        <div className="map-container">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d11924.23739004644!2d-73.7414121!3d41.4763134!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c2b7a158aac975%3A0x1c4c799c94732753!2sJet%20Black%20Limousine!5e0!3m2!1sen!2sus!4v1673452458886!5m2!1sen!2sus"
            className="map"
            title="Location"
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>

        <form className="form" onSubmit={handleSubmit}>
          <h3 className="form-title">Get in Touch</h3>
          <div className="input-group">
            <input type="text" placeholder="Name" className="input" required />
            <input type="email" placeholder="Email" className="input" required />
          </div>
          <div className="input-group">
            <input type="text" placeholder="Phone" className="input" required />
            <input type="text" placeholder="Subject" className="input" required />
          </div>
          <textarea placeholder="Message" className="textarea" required></textarea>
          <button type="submit" className="button">Send Message</button>
        </form>
      </div>

      {/* Pie de página */}
      <Footer />

      {/* Estilos en línea */}
      <style>
        {`
          .page-container {
            display: flex;
            flex-direction: column;
            font-family: Arial, sans-serif;
            background-color: #f8f8f8;
          }

          .hero-section {
            position: relative;
            width: 100%;
            height: 300px;
            overflow: hidden;
          }

          .background-image {
            width: 100%;
            height: 100%;
            object-fit: cover;
            filter: brightness(60%);
          }

          .hero-overlay {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .hero-text {
            color: #fff;
            font-size: 2.5rem;
            font-weight: bold;
            text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.8);
          }

          .contact-section {
            padding: 40px 20px;
            background-color: #ffffff;
            border-radius: 8px;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
            margin: 20px auto;
            max-width: 1200px;
          }

          .cards-row {
            display: flex;
            justify-content: space-between;
            gap: 20px;
          }

          .card {
            flex: 1;
            background-color: #fff;
            padding: 20px;
            border-radius: 8px;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
            text-align: center;
          }

          .icon {
            font-size: 2.5rem;
            color: #0d2b3e;
            margin-bottom: 10px;
          }

          .card-title {
            font-size: 1.2rem;
            font-weight: bold;
          }

          .map-and-form-container {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 20px;
            padding: 40px 20px;
            max-width: 1200px;
            margin: 0 auto;
          }

          .map-container {
            border-radius: 8px;
            overflow: hidden;
          }

          .map {
            width: 100%;
            height: 400px;
            border: none;
          }

          .form {
            background-color: #fff;
            padding: 30px;
            border-radius: 8px;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          }

          .form-title {
            font-size: 1.8rem;
            font-weight: bold;
            margin-bottom: 20px;
            color: #0d2b3e;
          }

          .input-group {
            display: flex;
            gap: 20px;
          }

          .input {
            width: 100%;
            padding: 12px;
            margin-bottom: 10px;
            border: 2px solid #ccc;
            border-radius: 4px;
            font-size: 1rem;
          }

          .textarea {
            width: 100%;
            padding: 12px;
            height: 120px;
            border: 2px solid #ccc;
            border-radius: 4px;
            font-size: 1rem;
          }

          .button {
            width: 100%;
            padding: 12px;
            background-color: #0d2b3e;
            color: #fff;
            border: none;
            border-radius: 4px;
            font-size: 1.2rem;
            font-weight: bold;
            cursor: pointer;
            transition: background-color 0.3s ease;
          }

          .button:hover {
            background-color: #09202e;
          }

          /* Ajustes para dispositivos móviles */
          @media (max-width: 768px) {
            .cards-row {
              flex-direction: column;
            }

            .map-and-form-container {
              grid-template-columns: 1fr;
            }

            .hero-text {
              font-size: 2rem;
            }
          }
        `}
      </style>
    </div>
  );
};

export default ContactPage;
